import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
    padding: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 12px;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;
